// Shared by Home (teaser) and Projects (full page).
const projects = [
  {
    id: 'serin-radar',
    name: 'Serin Radar',
    tagline: 'Know when something nearby is recording.',
    description:
      'A privacy tracker for your phone. It watches for smart glasses like Meta Ray-Bans, hidden cameras, and other nearby recording devices, and tells you when one shows up. Out on iOS now, with an Android release close behind.',
    status: 'iOS, Android soon',
    built: 'Native iOS app, with an Android version in progress.',
    url: 'https://serinradar.com',
    urlLabel: 'serinradar.com',
  },
  {
    id: 'handybench',
    name: 'Handybench',
    tagline: 'Small tools that do one job.',
    description:
      'A bench of simple, fast browser tools for the everyday stuff: converting, formatting, checking. No accounts, no clutter. It just went up, and new tools land as I need them.',
    status: 'Live',
    built: 'Plain web tools with no backend and no accounts.',
    url: 'https://handybench.com',
    urlLabel: 'handybench.com',
  },
  {
    id: 'this-site',
    name: 'This site',
    tagline: 'A home for my projects, built from scratch.',
    description:
      'A React front end on top of a Cloudflare Worker, with R2 storage behind it for media. No site builder, no template. Everything you are looking at is hand-built.',
    status: 'Live',
    built: 'Built with React, Cloudflare Workers, and R2.',
    url: 'https://github.com/cstebs',
    urlLabel: 'GitHub',
  },
];

export default projects;
